import React, { useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { syncBlockMessages } from '@atlaskit/editor-common/messages';
import { ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
import BlockSyncedIcon from '@atlaskit/icon-lab/core/block-synced';
import Lozenge from '@atlaskit/lozenge';
import { canBeConvertedToSyncBlock } from '../pm-plugins/utils/utils';
export var CreateSyncedBlockItem = function CreateSyncedBlockItem(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['selection', 'connectivity'], function (states) {
      var _states$selectionStat, _states$connectivityS;
      return {
        selection: (_states$selectionStat = states.selectionState) === null || _states$selectionStat === void 0 ? void 0 : _states$selectionStat.selection,
        mode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode
      };
    }),
    selection = _useSharedPluginState.selection,
    mode = _useSharedPluginState.mode;
  var isDisabled = Boolean(!selection || !canBeConvertedToSyncBlock(selection) || mode === 'offline');
  var onClick = useCallback(function () {
    var _api$core, _api$core2;
    api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(function (_ref2) {
      var tr = _ref2.tr;
      return api === null || api === void 0 ? void 0 : api.syncedBlock.commands.insertSyncedBlock()({
        tr: tr
      });
    });
    api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.focus();
  }, [api]);
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    onClick: onClick,
    isDisabled: isDisabled,
    elemBefore: /*#__PURE__*/React.createElement(BlockSyncedIcon, {
      size: "small",
      label: ""
    }),
    elemAfter: /*#__PURE__*/React.createElement(Lozenge, {
      appearance: "new"
    }, formatMessage(syncBlockMessages.newLozenge))
  }, formatMessage(syncBlockMessages.createSyncBlockLabel));
};